// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a02aa757","455":"824e45da","977":"2cbf0f37"}[chunkId] + ".chunk.js";
};